import { useEffect, useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { COUNTRIES } from '../constant/country';
import { AuthAction, GroupAction } from "../redux/action";
import Header from "./Header";
import { history } from "../history";
import Loader from "./Loader";


const Profile = ({ group, GroupInfo }) => {
    const user = JSON.parse(localStorage.getItem('user'));

    const [showLoader, setShowLoader] = useState(false);
    const [country, setCountry] = useState('');
    
    useEffect(() => {
        if (!user) {
            history.push('/');
        } else {
            setShowLoader(true);
            GroupInfo(user?.groupId).then(response => setCountry(getCountryName(response.data.countryCode)));
            setShowLoader(false);
        }
    }, [user]);

    const getCountryName = (code) => {
        var c = COUNTRIES.find(x => x.countryCode === code);
        return c ? c.name : <i>Undefined</i>;
    }

    return (
        <>
            <Header />
            <section className="wrapper">
                <div className="container py-15 py-md-16 pb-13 tb-account">
                    <div className="row">
                        <div className="col-xl-3 sidebar doc-sidebar xl-block">
                            <div className="widget">
                                <h4 className="mb-1"><img src="./assets/img/img_avatar_dark.svg" className="" />{user?.name}</h4>
                                <div className="accordion accordion-wrapper" id="accordion1">
                                    <div className="accordion-item">
                                        <div className="card-header" id="branch-1">
                                            <button className="collapsed" data-bs-toggle="collapse" data-bs-target="#branch-collapse-1" aria-expanded="true" aria-controls="branch-collapse-1"><span>계정 관리</span></button>
                                        </div>
                                        <div id="branch-collapse-1" className="card-body accordion-collapse collapse show" aria-labelledby="branch-1">
                                            <nav id="collapse-style">
                                                <ul className="list-unstyled text-reset">
                                                    <li className="active">프로필</li>
                                                    <li><a href="#" onClick={(e) => { e.preventDefault(); history.push('/config') }}>개인 설정</a></li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-9 order-2">
                            <section className="wrapper">
                                <h2>프로필</h2>
                                <div className="table-responsive mt-4">
                                    <table className="table table-order">
                                        <tbody>
                                            <tr>
                                                <td className="ps-0"><strong className="text-dark">Name</strong></td>
                                                <td className="pe-0" colSpan="2">
                                                    <p className="pb-2 pb-md-0">{user?.name}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ps-0"><strong className="text-dark">Email</strong></td>
                                                <td className="pe-0">
                                                    <p>{user?.email}</p>
                                                </td>
                                                <td className="pe-0 text-end">
                                                    <a href="./.html" className="btn btn-xs btn-soft-dark rounded-pill btn-x-lg">수정</a>
                                                </td>
                                            </tr>
                                            <tr style={{ display: "none" }}>
                                                <td className="ps-0"><strong className="text-dark">Email</strong></td>
                                                <td className="pe-0 td-input">
                                                    <input type="email" className="form-control" placeholder="Email *" id="email" />
                                                </td>
                                                <td className="pe-0 text-end">
                                                    <a href="./.html" className="btn btn-xs btn-dark rounded-pill btn-x-lg">취소</a>
                                                    <a href="./.html" className="btn btn-xs btn-primary rounded-pill btn-x-lg">저장</a>
                                                </td>
                                            </tr>
                                            <tr style={{ display: "none" }}>
                                                <td className="ps-0"><strong className="text-dark">Password</strong></td>
                                                <td className="pe-0">
                                                    <p>******</p>
                                                </td>
                                                <td className="pe-0 text-end">
                                                    <a href="./.html" className="btn btn-xs btn-soft-dark rounded-pill btn-x-lg">수정</a>
                                                </td>
                                            </tr>
                                            <tr style={{ display: "none" }}>
                                                <td className="ps-0"><strong className="text-dark">Password</strong></td>
                                                <td className="pe-0 td-input">
                                                    <div className="row col-md-12">
                                                        <div className="col-md-6">
                                                            <input type="password" className="form-control mb-2 mb-md-0" id="password" placeholder="Password *" value="" required />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <input type="password" className="form-control" id="passwordConfirm" placeholder="Confirm Password *" value="" required />
                                                        </div>
                                                    </div>
                                                    <div className="invalid-feedback">Password fields is empty</div>
                                                </td>
                                                <td className="pe-0 text-end">
                                                    <a href="./.html" className="btn btn-xs btn-dark rounded-pill btn-x-lg">취소</a>
                                                    <a href="./.html" className="btn btn-xs btn-primary rounded-pill btn-x-lg">저장</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ps-0"><strong className="text-dark">Country</strong></td>
                                                <td className="pe-0">
                                                    <p>{country || 'South Korea'}</p>
                                                </td>
                                                <td className="pe-0 text-end">
                                                    <a href="./.html" className="btn btn-xs btn-soft-dark rounded-pill btn-x-lg">수정</a>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ps-0"><strong className="text-dark">Last Login</strong></td>
                                                <td className="pe-0" colSpan="2">
                                                    <p className="pb-2 pb-md-0">{moment(user?.lastlogged).format('LL')}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="ps-0"><strong className="text-dark">Created</strong></td>
                                                <td className="pe-0" colSpan="2">
                                                    <p className="pb-2 pb-md-0">{moment(user?.updated).format('LL')}</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
            <Loader isShow={showLoader} />
        </>
    )
}

const mapState = (state) => {
    const group = state.GroupReducer.item;

    return { group }
}

const mapDispatch = dispatch => ({
    GroupInfo: (_id) => dispatch(GroupAction.Get(_id))
});

export default connect(mapState, mapDispatch)(Profile);